module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-e0a1c8eb0180f95bdb575855f1bcf90e.png";